var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [(_vm.closeButton) ? _c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHeader) ? _c('div', {
    staticClass: "uk-modal-header"
  }, [_vm._t("header", [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v(_vm._s(_vm.title))])])], 2) : _vm._e(), _vm._v(" "), (_vm.playground) ? _vm._t("default") : _c('div', [_c('div', {
    staticClass: "uk-modal-body",
    attrs: {
      "uk-overflow-auto": _vm.autoOverflow
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "uk-modal-footer uk-text-right"
  }, [_vm._t("footer", [_vm._t("buttons"), _vm._v(" "), _c('common-button', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('close')) + "\n          ")])])], 2) : _vm._e()])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8533877c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Modal.vue
// module id = 2076
// module chunks = 0